import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'undeliverable-parcels' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
